var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scrollable-container b-0", class: _vm.containerMargin },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLeftArrow,
              expression: "showLeftArrow",
            },
          ],
          staticClass: "scroll-control scroll-left",
          staticStyle: { left: "0 !important" },
          on: { click: _vm.handleScrollLeft },
        },
        [_c("i", { staticClass: "fa fa-chevron-left" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "scrollRef" },
        [_vm._t("default", null, { recalculateWidth: _vm.recalculateWidth })],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRightArrow,
              expression: "showRightArrow",
            },
          ],
          staticClass: "scroll-control scroll-right",
          staticStyle: { right: "0 !important" },
          on: { click: _vm.handleScrollRight },
        },
        [_c("i", { staticClass: "fa fa-chevron-right" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }